// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZFRNB","text":"styles_text__ricxd","buttonText":"styles_buttonText__lmZJK"};